var sources = document.querySelectorAll('.testimonials__source');

var activate = function() {
  for (var i = 0; i < sources.length; i += 1) {
    sources[i].classList.remove('testimonials__source--active');
    sources[i].previousElementSibling.classList.remove('testimonials__item--active');
  }
  this.classList.add('testimonials__source--active');
  this.previousElementSibling.classList.add('testimonials__item--active');
};

for (var i = 0; i < sources.length; i += 1) {
  sources[i].addEventListener('click', activate);
}

if (sources.length) {
  activate.call(sources[0]);
}
